export const pointsOptions = {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    sign: "always"
};
//# sourceMappingURL=pointsOptions.js.map